
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from 'react-i18next';

interface PlanLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  imageUrl?: string;
}

export const PlanLayout = ({ title, subtitle, children, imageUrl }: PlanLayoutProps) => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0f1f3d] to-[#1a2f50] text-white">
      {/* 上部ナビゲーション */}
      <header className="px-4 md:px-8 py-5 flex items-center">
        <Link
          to="/#business-plans"
          className="flex items-center gap-2 text-white/70 hover:text-[#c9a84c] transition-colors duration-200 text-sm font-medium"
        >
          <ArrowLeft className="h-4 w-4" />
          <span>{t('planlayout.backToTop')}</span>
        </Link>
      </header>

      <div className="max-w-4xl mx-auto px-4 pb-20">
        {/* Hero */}
        <motion.section
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="mb-10"
        >
          {imageUrl && (
            <div className="w-full h-56 md:h-72 overflow-hidden rounded-xl mb-8 shadow-lg">
              <img
                src={imageUrl}
                alt={title}
                className="w-full h-full object-cover opacity-60"
              />
            </div>
          )}
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-2 leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="text-lg text-white/60 mt-1">{subtitle}</p>
          )}
          {/* ゴールドアンダーライン */}
          <div className="mt-4 h-1 w-16 rounded-full bg-gradient-to-r from-[#c9a84c] to-[#d97706]" />
        </motion.section>

        {/* コンテンツ */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
        >
          {children}
        </motion.div>
      </div>
    </div>
  );
};
